import { IconName } from '@optimus-web/icons';
import { TextKey } from '@mews-commander/enums';
import { UserGroupAccessPolicyType } from '@mews-commander/data-access';

export const getRolesAndPermissionsOptionsValues = () => [
    {
        icon: IconName.Security,
        label: TextKey.UserProfilePermissionTypeAdminTitle,
        value: UserGroupAccessPolicyType.Admin,
        description: TextKey.UserProfilePermissionTypeAdminDescription,
    },
    {
        icon: IconName.Employees,
        label: TextKey.UserProfilePermissionTypeRolesTitle,
        value: UserGroupAccessPolicyType.RoleBased,
        description: TextKey.UserProfilePermissionTypeRolesDescription,
    },
    {
        icon: IconName.Lock,
        label: TextKey.UserProfilePermissionTypeNoPermissionsTitle,
        value: UserGroupAccessPolicyType.NoAccess,
        description: TextKey.UserProfilePermissionTypeNoPermissionsDescription,
    },
];
